function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4922 2.40625H11.1406V2.05469C11.1406 1.47313 10.6675 1 10.0859 1H3.05469C2.47313 1 2 1.47313 2 2.05469V10.5391C2 11.1206 2.47313 11.5938 3.05469 11.5938H3.40625V11.9453C3.40625 12.5269 3.87938 13 4.46094 13H11.4922C12.0737 13 12.5469 12.5269 12.5469 11.9453V3.46094C12.5469 2.87938 12.0737 2.40625 11.4922 2.40625ZM3.71516 3.70954C3.51594 3.90873 3.40625 4.17358 3.40625 4.4553V10.8906H3.05469C2.86084 10.8906 2.70312 10.7329 2.70312 10.5391V2.05469C2.70312 1.86084 2.86084 1.70312 3.05469 1.70312H10.0859C10.2798 1.70312 10.4375 1.86084 10.4375 2.05469V2.40625H5.4553C5.17358 2.40625 4.90873 2.51596 4.70954 2.71516L3.71516 3.70954ZM5.51562 3.10938V4.51562H4.10938V4.4553C4.10938 4.36141 4.14594 4.27312 4.21234 4.20672L5.20672 3.21234C5.27312 3.14594 5.36141 3.10938 5.4553 3.10938H5.51562ZM11.8438 11.9453C11.8438 12.1392 11.686 12.2969 11.4922 12.2969H4.46094C4.26709 12.2969 4.10938 12.1392 4.10938 11.9453V5.21875H5.86719C6.06134 5.21875 6.21875 5.06134 6.21875 4.86719V3.10938H11.4922C11.686 3.10938 11.8438 3.26709 11.8438 3.46094V11.9453Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7891 5.96875H5.16406C4.96991 5.96875 4.8125 6.12616 4.8125 6.32031C4.8125 6.51447 4.96991 6.67188 5.16406 6.67188H10.7891C10.9832 6.67188 11.1406 6.51447 11.1406 6.32031C11.1406 6.12616 10.9832 5.96875 10.7891 5.96875Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7891 7.375H5.16406C4.96991 7.375 4.8125 7.53241 4.8125 7.72656C4.8125 7.92072 4.96991 8.07812 5.16406 8.07812H10.7891C10.9832 8.07812 11.1406 7.92072 11.1406 7.72656C11.1406 7.53241 10.9832 7.375 10.7891 7.375Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7891 8.78125H5.16406C4.96991 8.78125 4.8125 8.93866 4.8125 9.13281C4.8125 9.32697 4.96991 9.48438 5.16406 9.48438H10.7891C10.9832 9.48438 11.1406 9.32697 11.1406 9.13281C11.1406 8.93866 10.9832 8.78125 10.7891 8.78125Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7891 10.1875H5.16406C4.96991 10.1875 4.8125 10.3449 4.8125 10.5391C4.8125 10.7332 4.96991 10.8906 5.16406 10.8906H10.7891C10.9832 10.8906 11.1406 10.7332 11.1406 10.5391C11.1406 10.3449 10.9832 10.1875 10.7891 10.1875Z",
  fill: "currentColor"
});

function SvgDocicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocicon);
export default __webpack_public_path__ + "static/media/doc.icon.b29d0171.svg";
export { ForwardRef as ReactComponent };